import React, { useCallback } from 'react';

import classNames from 'classnames';
import parseISO from 'date-fns/parseISO';

import { StyledOcticon } from '@primer/react';

import formatRelativeDate from '../../../utils/format_relative_date';
import { getThemeColor } from '../../../utils/theme-utils';

import DividerDot from '../../common/misc/DividerDot';
import Icon from '../../common/icons/Icon';
import IndexIcon from '../../common/IndexIcon/IndexIcon';
import Label from '../../common/Labels/Label';
import ModelIcon from '../../common/icons/ModelIcon';

export const ModelSingleSelectionItem = ({
  index, model, onSelect, showIndex = false, selected = false, disabled = false,
}) => {
  const modelID = model?.modelID;
  const handleSelection = useCallback(() => {
    if (onSelect) {
      onSelect(modelID, index);
    }
  }, [index, modelID, onSelect])

  const lastUpdateDate = formatRelativeDate(parseISO(model?.updatedAt));

  // Cannot pass IndexedIcon to StyledOcticon without defining component inside render
  // eslint-disable-next-line
  const IndexedIcon = props => <IndexIcon index={index + 1} {...props} />

  return (
    <button
      type="button"
      className={classNames(
        'flex items-center p-4 w-full',
        { 'bg-white hover:bg-border-light': !selected },
        { 'bg-border-dark': selected },
        { 'opacity-50': disabled },
        { 'cursor-pointer': !disabled },
      )}
      onClick={handleSelection}
      disabled={disabled}
    >
      {
        showIndex ? <StyledOcticon icon={IndexedIcon} /> : null
      }
      <Icon fill={getThemeColor('brand')} icon={ModelIcon} size={48} useTailwindSizing />
      <div className="flex flex-col justify-start items-start p-2">
        <Label bold>{modelID}</Label>
        <div className="flex">
          <Label>Model</Label>
          <DividerDot />
          <Label>Last Updated {lastUpdateDate}</Label>
        </div>
      </div>
    </button>
  )
}

export default ModelSingleSelectionItem;
